import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// In-app navigations don't reload the page, so GTM (loaded in
// public/index.html) only sees the first load on its own. Push a
// `virtual_page_view` event for every later route change; trigger on it in
// GTM with a Custom Event trigger.
//
// Module-level so it survives App remounting between routes. The first URL
// App renders is only recorded, not pushed: GTM's gtm.js event already
// covers the initial load (including the "/" → "/community" redirect).
let lastPushedUrl = null;

export const useDataLayerPageView = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const url = pathname + search;
    const isInitialLoad = lastPushedUrl === null;
    if (url === lastPushedUrl) return;
    lastPushedUrl = url;
    if (isInitialLoad) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtual_page_view",
      page_path: url,
      page_location: window.location.href,
    });
  }, [pathname, search]);
};
